module.exports = __webpack_public_path__ + "static/neeti-becf0a4beb0e70601550b68e3368db55.png";